import * as React from "react";
import BookmarkListItem from "./bookmarkListItem";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

interface SelectedBookmarksListProps {
    items: any[];
    onDragEnd: (result: any) => void;
}

class BookmarkCategories extends React.Component<SelectedBookmarksListProps> {
    constructor(props) {
        super(props);
        this.state = { isLoaded: false };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.items !== this.props.items) {
            this.setState({ isLoaded: true });
        }
    }

    render() {
        const { items, onDragEnd } = this.props;
        const { isLoaded } = this.state;
        const hasItems = items.length > 0;

        return (
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="bookmarkList">
                    {(provided) => (
                        <div
                            className={`hero-menucontent__list ${isLoaded && !hasItems ? "no-list" : ""}`}
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                        >
                            {items.map((bookmark, index) => (
                                <Draggable
                                    key={bookmark.id || index}
                                    draggableId={bookmark.id || index.toString()}
                                    index={index}
                                >
                                    {(provided) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            className="hero-menucontent__list-item-draggable"
                                        >
                                            <BookmarkListItem bookmark={bookmark} />
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        );
    }
}

export default BookmarkCategories;